import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocDisplayType, LocMap, MapLocKeys } from '@cm/core/localization';

const pathStart = 'Tools|Exams Under Review|';

export type SPExamPendingReviewLocNames =
	| 'SPExamPendingReviewButtonValidate'
	| 'SPExamPendingReviewButtonInValidate'
	| 'SPExamPendingReviewChangesSaved';

export const spExamPendingReviewLocs: LocDefs<SPExamPendingReviewLocNames> = {
	SPExamPendingReviewButtonValidate: {
		defaultValue: 'Review as Validated',
		description: 'Button to review selected exams as validated',
		displayPath: `${pathStart}Review As Validated`,
		displayType: 'Button' as LocDisplayType,
		feature: HubFeature.BulkCandidateTools,
		portal: 'SP',
	},
	SPExamPendingReviewButtonInValidate: {
		defaultValue: 'Review as Invalidated',
		description: 'Button to review selected exams as validated',
		displayPath: `${pathStart}Review As Validated`,
		displayType: 'Button' as LocDisplayType,
		feature: HubFeature.BulkCandidateTools,
		portal: 'SP',
	},
	SPExamPendingReviewChangesSaved: {
		defaultValue: 'Changes Saved',
		description:
			'Notification shown when exam(s) are successfully reviewed as validated or invalidated',
		displayPath: `${pathStart}|Review Success Notification`,
		displayType: 'Notification' as LocDisplayType,
		feature: HubFeature.BulkCandidateTools,
		portal: 'SP',
	},
};

export const LOC_KEYS = MapLocKeys<SPExamPendingReviewLocNames>(spExamPendingReviewLocs);
export type SPExamPendingReviewLocType = LocMap<SPExamPendingReviewLocNames>;
